import { Component, HostBinding, Output, EventEmitter, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { DataService } from '../../_services/data.service';
import { Item } from '../../_core/_interface/item';
import { Flat } from '../../_core/_interface/flat';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { threadId } from 'worker_threads';
import { Title } from '@angular/platform-browser';
// import { ConsoleReporter } from 'jasmine';
import { Location } from '@angular/common';
// import { AuthService } from 'src/app/_services/auth.service';
import { User } from 'src/app/_core/_interface/user';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { AddOfferComponent } from '../offers-components/add-offer/add-offer.component';
import { AuthService } from 'src/app/_services/auth.service';
import { HttpClient } from '@angular/common/http';
import { anim, slideRight, slideUp } from 'src/app/animations';
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';


export function isFullScreen(): boolean {
  const fsDoc = <any>document;

  return !!(fsDoc.fullscreenElement || fsDoc.mozFullScreenElement || fsDoc.webkitFullscreenElement || fsDoc.msFullscreenElement);
}
interface FsDocumentElement extends HTMLElement {
  msRequestFullscreen: () => void;
  mozRequestFullScreen: () => void;
  webkitRequestFullscreen: () => void;
}

@Component({
  selector: 'app-calculator-offer',
  templateUrl: './calculator-offer.component.html',
  styleUrls: ['./calculator-offer.component.scss'],
  animations: [
    trigger('slideRight', [

      state('void', style({ transform: 'translateX(-100%)', opacity: 0 })),

      transition('void => *, * => void', [
        animate(1000)
      ])
    ]),
    anim,
    slideRight,
    slideUp
  ]
})
export class CalculatorOfferComponent {


  @HostBinding('class.not-centered-content') slide: boolean = false;
  items: Flat = {
    number: 0,
    buildId: '',
    compId: '',
    floorId: '',
    projId: '',
    startPoint: 0,
    name: '',
    flatSize: 0,
    numberOfBathrooms: 0,
    uid: '',
    faltPrototype: '',
    builUid: '',
    floorNumber: 0,
    floorTitle: '',
    id: '',
    curFloorPanorama: ''
  };

  showContent = false;
  itemToEdit: Item;
  fullScreenDrawing = false;
  fullScreenSpirical = false;
  fullScreenInterior = false;
  fullScreenGallery = false;
  public compId;
  public flatProperties;
  fullscreen = false;
  routeNavigate: any;
  fullScreen: boolean = false;
  iframeElement;
  proj: any;
  mainSpiricalSrc = "";
  showCopyNote: boolean = false;
  contactName: any;
  contactPhoneNumber: any;
  compTitle: string = '';
  toggleMenuTab: boolean = true;
  flatId: string;
  floorId: string;
  projId: string;
  projUid: string;
  build: any;
  buildName: any;

  @Output() hideFlatPropeties: EventEmitter<any> = new EventEmitter<any>();

  // @Output() public hideFlatPropeties = new EventEmitter();


  elRef: any;
  observer: any;
  building: any;
  flat: any;
  mainSpiricalSrcUpdated: boolean = false;
  showPhone: boolean = false;
  showPhoneNumber: boolean = false;
  phoneNumber: number;
  freeText: string = '';
  removeCloseButton: boolean = false;
  projTile: string;
  buildingTile: string;
  title: string;
  titleWhatsapp: string;
  curFloor: any;
  compositeDesign: boolean = false;
  unika: boolean = false;
  mySubscription: any;
  showFlatProperties: boolean;
  shareflatgallery: boolean = true;
  shareflatgalleryOfBuilding: boolean = true;
  simpleGallery: boolean = true;
  desktopResolution: boolean = true;
  companyTitle: '';
  projectTitle: '';
  removeAllMenu: any;
  buildUid: string;
  buildingName: string;
  user: User;
  withBuilding: boolean = false;
  plan: boolean = true;
  currentLang: string;
  areaCode: string = '+972';
  areaCodes: any[] = ['+972', '+7', '+357', '+380', '+1', '+995'];
  dataToDialog: any = {};
  withOutPrototype: any;
  urlSwitcher: string = '';
  three: Element;
  ifThree: boolean = true;
  titleWhatsappSehel: string = '';
  sehelUser: string = '';
  postData: any = {};
  sehelProjId: string = '';
  galCounter: number = 0;
  isUrl: boolean = false;
  illustrationOnly: boolean = false;
  illustrationOnlyNote: string = "";
  curFloorId: string = '';
  withDrawing: boolean = false;
  aboutProjectShow: boolean = false;
  hideRightMenu: boolean = false;
  airDirectionDeg: number = 0;
  horizontalLookAt: boolean = false;
  textWhatsapp1: string = "";
  propertyName: string = "";

  textWhatsapp2: string = "";
  hide360PanoInFlat: boolean = true;
  wholeNum: boolean = false;
  flatNumber: string;
  appartmentsIdArray: [{
    building: string,
    number: any
  }];
  host: any;
  propertiesMenuChangePlace: boolean = false;
  buildType: string = '';
  refresh: boolean = true;

  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private location: Location,
    private translate: TranslateService,
    private auth: AuthService,
    public dialog: MatDialog,
    private http: HttpClient,
    private renderer: Renderer2, 
    private el: ElementRef
    // private auth: AuthService
  ) {
    this.flatId = this.route.snapshot.params.flatId;
    this.compId = this.route.snapshot.params.id;
    this.sehelUser = this.route.snapshot.params.seheluser;
    this.postData.clientId = this.route.snapshot.params.seheluser;
    // this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //   return true;
    // };
    // this.mySubscription = this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     // Trick the Router into believing it's last link wasn't previously loaded
    //     this.router.navigated = true;
    //   }
    // });
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
  }

  ngOnInit() {
    // this.areaCode = '+972';
    //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //     return true;
    // };
    // this.user = this.auth.currentUserValue;
    // this.three = document.getElementsByTagName('app-threejs')[0];


    this.textWhatsapp1 = this.translate.instant('TEXT-WHATSAP-1');
    this.textWhatsapp2 = this.translate.instant('TEXT-WHATSAP-2');
    this.propertyName = this.translate.instant('PROPERTY-NAME');

    if (this.route.snapshot.queryParams.m === 'n' || this.route.snapshot.queryParams.m === 'buildings') {
      this.hideRightMenu = true;
    }
    setTimeout(() => {
      this.toggleMenuTab = false;
    }, 3000);
    this.projUid = this.route.snapshot.params.idp;
    this.fullScreenGallery = false; 
    this.fullScreenSpirical = false;
    this.fullScreenInterior = false;
    this.fullScreenDrawing = false;
    if (document.getElementsByTagName('app-threejs').length > 0) {
      this.ifThree = false;
    }

    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    console.log('this.compositeDesign ', this.compositeDesign);
    console.log('this.unika ', this.unika);
    this.user = this.auth.currentUserValue;
    this.buildingName = JSON.parse(localStorage.getItem('buildingName'));
    this.removeAllMenu = localStorage.getItem('removeAllMenu');


    let companyAndProject = null;
    if (companyAndProject === null) {
      setTimeout(() => {
        companyAndProject = localStorage.getItem('companyAndProject');
        const objcompanyAndProject = JSON.parse(companyAndProject);
        this.companyTitle = objcompanyAndProject.companyName;
        this.projectTitle = objcompanyAndProject.projectName;
      }, 1000);
    } else {
      const objcompanyAndProject = JSON.parse(companyAndProject);
      this.companyTitle = objcompanyAndProject.companyName;
      this.projectTitle = objcompanyAndProject.projectName;
    }
    console.log(companyAndProject);
    if (window.innerWidth < 1200) {
      this.desktopResolution = false;
    }
    if (this.compositeDesign || this.unika) {
      this.removeCloseButton = true;
    }
    if (this.route.snapshot.queryParams.m === 'all') {
      this.removeCloseButton = true;
    }
    if (this.unika) {
      this.routeNavigate = 'https://spirical.net' + location.pathname + "?m=n";
    } else {
      this.routeNavigate = 'https://spirical.net' + location.pathname + "?m=all";
    }
    this.compTitle = this.dataService.hoisUrlGetTitle();

    this.dataService.getSpecOffer(this.route.snapshot.paramMap.get('userId')).subscribe(offer => {
      console.log(offer);

      let offer1: any = offer[0];
      this.appartmentsIdArray = offer1.appartmentsIdArray;
      this.buildUid = offer1.appartmentsIdArray[0].building;
      this.flatNumber = offer1.appartmentsIdArray[0].number;
      this.projId = this.route.snapshot.paramMap.get('idp');
      this.compId = this.route.snapshot.paramMap.get('id');
      const dataService = this.dataService;
      // this.host = location.hostname + this.urlSwitcher + this.compId + this.projUid + this.buildUid
      this.dataService.getSpecBuilding(this.buildUid).subscribe(building => {
        // changes 26012023 if (building[0])
        if (building[0]) {
          this.building = building[0];
          console.log(this.building);
          this.buildType = this.building.buildType;
          if (this.buildType === 'office' || (this.building.planIsFirst == null || this.building.planIsFirst)) {
            this.propertiesMenuChangePlace = true;
          }
          if (building.length > 0) {
            if (building[0].name) {
              this.buildingTile = building[0].name;
            }
          }
          this.buildName = building[0].name;
          this.withBuilding = building[0].withBuilding;
          if (building[0].hide360PanoInFlat !== undefined) {
            this.hide360PanoInFlat = building[0].hide360PanoInFlat;
          }
          this.contactName = offer1.seller.name;
          if(offer1.seller.phone) {
            this.contactPhoneNumber = offer1.seller.phone;
          }
          this.buildUid = building[0].uid;
          if (building[0].withOutPrototype) {
            this.withOutPrototype = building[0].withOutPrototype;
          }

          this.pageTitle();
          let floors = this.building.floors;
          floors.forEach(floor => {
            let currentFlats = floor.floor.flats.filter(flat => flat.number === this.flatNumber);
            if (currentFlats.length > 0) {
              this.flat = currentFlats[0];
              this.flat.buildName = this.buildName
              this.items = currentFlats;
              this.items[0].floorTitle = floor.floor.title;
              this.items[0].floorNumber = floor.floor.number;
              this.horizontalLookAt = building[0].horizontalLookAt;
              if (this.horizontalLookAt === true && this.items[0].airDirection !== 0) {
                let inputString = this.items[0].airDirection.trim();
                let parts = inputString.split('+');
                parts = inputString.split(',');
                inputString = parts[0];

                switch (inputString.trim()) {
                  case 'מע':
                  case 'צפ מע דר מז':
                  case 'דר מע מז צפ':
                  case 'w':
                    this.airDirectionDeg = 0;
                    this.airDirectionDeg = -90;
                    break;
                  case 'דר':
                  case 'דרום':
                  case 'מז מע':
                  case 'דר מז מע':
                  case 'דר, מז, מע':
                  case 's':
                    this.airDirectionDeg = 0;
                    this.airDirectionDeg = -180;
                    break;
                  case 'ד מז':
                  case 'דר מז':
                  case 'דר-מז':
                  case 'e-s':
                  case 'e-s':
                  case 'se':
                    this.airDirectionDeg = 0;
                    this.airDirectionDeg = 135;
                    break;
                  case 'צפ מע':
                  case 'צ מע':
                  case 'צפ-מע':
                  case 'צפון מע':
                  case 'n-w':
                  case 'nw':
                    this.airDirectionDeg = -45;
                    break;
                  case 'מע':
                  case 'צפ דר מע':
                  case 'מערב':
                  case 'מע צפ דר':
                  case 'w':
                    this.airDirectionDeg = -90;
                    break;
                  case 'צ מז':
                  case 'צפ מז':
                  case 'n-e':
                  case 'צפ-מז':
                  case 'ne':
                    this.airDirectionDeg = 45;
                    break;
                  case 'מז':
                  case 'מזרח':
                  case 'מז דר צפ':
                  case 'דר-מז-צפ':
                  case 'e':
                    this.airDirectionDeg = 90;
                    break;
                  case 'צפ':
                  case 'צפ מז מע':
                  case 'צפון':
                  case 'צפ מע מז':
                  case 'צפ, מז, מע':
                  case 'n':
                    this.airDirectionDeg = 0;
                    break;
                  case 'דר מע':
                  case 'ד מע':
                  case 'דר-מע':
                  case 's-w':
                  case 'sw':
                    this.airDirectionDeg = -135;
                    break;
                  default:
                    console.log(this.items[0].airDirection.trim());
                }
              }
              if (this.building.horizontalLookAtStartPoint > 0) {
                this.airDirectionDeg += this.building.horizontalLookAtStartPoint;
              }
              // ms group bein shderot was a problem
              // if (this.flat.compId === 'A3ZPcNzU3ArlnpJ0GOXB' && this.horizontalLookAt === true && this.items[0].airDirection !== 0) {
              //   switch (this.items[0].airDirection.trim()) {
              //     case 'צפ':
              //     case 'צ':
              //     case 'צפ מז מע':
              //     case 'צפון':
              //       this.airDirectionDeg = 0;
              //       break;
              //     default:
              //       console.log(this.items[0].airDirection.trim());
              //   }
              // }
              if (!this.items[0].curFloorPanorama) {
                this.items[0].curFloorPanorama = floor.floor.panoramaView;
              }
              this.curFloorId = floor.floor.id;
              if (floor.withDrawing) {
                this.withDrawing = floor.withDrawing;
              }
              // this.postData.apartmentId = this.items[0].number;
              this.curFloor = floor.floor;
              console.log('flatT: ', this.flat);
            }
          });
          if (this.flat && !this.withOutPrototype) {
            setTimeout(() => { this.showHotspot(this.flat); }, 3000);
            setTimeout(() => { this.showHotspot(this.flat); }, 5000);
            setTimeout(() => { this.showHotspot(this.flat); }, 7000);
            setTimeout(() => { this.showHotspot(this.flat); }, 10000);
            if (this.flat.faltPrototype !== '' || this.flat.faltPrototype !== undefined) {
              this.dataService
                .getSpecFlatPrototypeView(this.flat.faltPrototype)
                .subscribe(prototype => {
                  this.flatProperties = prototype;
                  if (this.flatProperties.length > 0) {
                    if (this.flatProperties[0].sideNames) {
                      const flatViewName = this.flatProperties[0].sideNames[0];
                      if (this.curFloor[flatViewName]) {
                        this.items[0].curFloorPanorama = this.curFloor[flatViewName];
                        if (this.items[0].curFloorPanorama.hostname) {
                          this.isUrl = true;
                        }
                      }
                    }
                  }
                });
            }
          } else if (this.withOutPrototype && this.flat) {
            let array = []

            if (this.flat.curFloorPanorama) {
              if (this.flat.curFloorPanorama.indexOf("http") > -1) {
                this.isUrl = true;
              }
            }
            if (this.flat.faltPrototype !== '' && this.flat.faltPrototype !== undefined) {
              this.dataService
                .getSpecFlatPrototypeView(this.flat.faltPrototype)
                .subscribe(prototype => {
                  this.flatProperties[0].protoId = prototype[0].id;
                  // this.flatProperties[0].flatInterior = prototype[0].flatInterior;
                });
            }
            array.push(this.flat);
            this.flatProperties = array;
          }
          this.dataToDialog.flat = this.flat;
          this.dataToDialog.user = this.user;
          this.dataService.setCurrentUnit(this.flat);
        }
      })
    });

    this.dataService.getSpecProject(this.route.snapshot.paramMap.get('idp')).subscribe(proj => {
      this.projPassFromMenu(proj);
      this.projUid = proj[0].uid;
      this.projTile = proj[0].title;
      this.wholeNum = proj[0].wholeNum;
      console.log("====================================================================", proj[0].wholeNum)
      this.illustrationOnly = proj[0].illustrationOnly;
      this.illustrationOnlyNote = proj[0].illustrationOnlyNote;
      this.companyTitle = proj[0].companyTitle;
      this.pageTitle();
      console.log(proj[0].title)
      this.dataToDialog.proj = this.proj;
      if (proj[0].aboutProjectShow) {
        this.aboutProjectShow = proj[0].aboutProjectShow;
      }
      setTimeout(() => {
        this.pageTitle();
      }, 1000);
      //SEHEL--------------
      setTimeout(() => {
        //   const postData = JSON.stringify({
        //     "token": "spirikal-427c-4921-927b-795020264f93"
        //   });
        //   if (this.flatProperties) {
        //     this.http.post<any>('https://dev.sehel.co.il/api/3d/setFavorite/a246afb5-427c-4921-927b-795020264f93/1/0/37/0526802211', postData).subscribe(data => {
        //       console.log('data', data);
        //     });
        //   }



        // let postData: any = {}
        // // postData.message = this.titleWhatsappSehel + '\n' + this.routeNavigate;
        // postData.token = "spirikal-427c-4921-927b-795020264f93";
        // postData.phone = '0503055157';

        // postData = JSON.stringify(postData);
        // this.http.post<any>('https://crm.sehel.co.il/api/3d/setFavorite/a503d275-11a5-4283-b5d9-4b9abbd66508/1/0/15', postData).subscribe(data => {
        //     console.log('data', data);
        //   });
      }, 3000);
    })

    setTimeout(function () {
      if (document.getElementsByClassName('3d-flat-holder').length > 0) {
        let obj3d = document.getElementsByTagName('app-threejs')[0];
        let container = document.getElementsByClassName('3d-flat-holder')[0];
        container.append(obj3d);
      }
    }, 1000);
  }

  // ngAfterViewInit(){

  //     document.getElementsByClassName('composite-design')[0].classList.add('remove-menu')

  // }

  ifFloorIdIsFloorNumber(floorId) {
    const numberString = floorId.toString();
    if (numberString.length < 5) {
      return true;
    } else {
      return false;
    }
  }

  changeUnitToShow(buildingUid, flatNumber) {
    this.propertiesMenuChangePlace = true;
    let building: any;
    this.buildUid = buildingUid;
    if (this.building.uid !== buildingUid) {
      let build = this.dataService.getSpecBuilding(buildingUid).subscribe(newBuilding => {
        building = newBuilding;
        this.building = newBuilding[0];
        this.buildName = this.building.name;
        this.changeUnit(building, flatNumber);
      });
    } else {
      building = this.building;
      this.changeUnit(building, flatNumber);
    }
 
  }

  changeUnit(building, flatNumber){
    if (building) {
      if (building.withOutPrototype) {
        this.withOutPrototype = building.withOutPrototype;
      }
      this.flatNumber = flatNumber
      let floors = this.building.floors;
      floors.forEach(floor => {
        let currentFlats = floor.floor.flats.filter(flat => flat.number === this.flatNumber);
        if (currentFlats.length > 0) {
          this.flat = currentFlats[0];
          this.dataService.setCurrentUnit(this.flat);
          this.flat.buildName = this.buildName
          this.items = currentFlats;
          this.items[0].floorTitle = floor.floor.title;
          this.items[0].floorNumber = floor.floor.number;
          this.horizontalLookAt = building.horizontalLookAt;
          if (this.horizontalLookAt === true && this.items[0].airDirection !== 0) {
            let inputString = this.items[0].airDirection.trim();
            let parts = inputString.split('+');
            parts = inputString.split(',');
            inputString = parts[0];

            switch (inputString.trim()) {
              case 'מע':
              case 'צפ מע דר מז':
              case 'דר מע מז צפ':
              case 'w':
                this.airDirectionDeg = 0;
                this.airDirectionDeg = -90;
                break;
              case 'דר':
              case 'דרום':
              case 'מז מע':
              case 'דר מז מע':
              case 'דר, מז, מע':
              case 's':
                this.airDirectionDeg = 0;
                this.airDirectionDeg = -180;
                break;
              case 'ד מז':
              case 'דר מז':
              case 'דר-מז':
              case 'e-s':
              case 'e-s':
              case 'se':
                this.airDirectionDeg = 0;
                this.airDirectionDeg = 135;
                break;
              case 'צפ מע':
              case 'צ מע':
              case 'צפ-מע':
              case 'צפון מע':
              case 'n-w':
              case 'nw':
                this.airDirectionDeg = -45;
                break;
              case 'מע':
              case 'צפ דר מע':
              case 'מערב':
              case 'מע צפ דר':
              case 'w':
                this.airDirectionDeg = -90;
                break;
              case 'צ מז':
              case 'צפ מז':
              case 'n-e':
              case 'צפ-מז':
              case 'ne':
                this.airDirectionDeg = 45;
                break;
              case 'מז':
              case 'מזרח':
              case 'מז דר צפ':
              case 'דר-מז-צפ':
              case 'e':
                this.airDirectionDeg = 90;
                break;
              case 'צפ':
              case 'צפ מז מע':
              case 'צפון':
              case 'צפ מע מז':
              case 'צפ, מז, מע':
              case 'n':
                this.airDirectionDeg = 0;
                break;
              case 'דר מע':
              case 'ד מע':
              case 'דר-מע':
              case 's-w':
              case 'sw':
                this.airDirectionDeg = -135;
                break;
              default:
                console.log(this.items[0].airDirection.trim());
            }
          }
          if (this.building.horizontalLookAtStartPoint > 0) {
            this.airDirectionDeg += this.building.horizontalLookAtStartPoint;
          }
          if (!this.items[0].curFloorPanorama) {
            this.items[0].curFloorPanorama = floor.floor.panoramaView;
          }
          this.curFloorId = floor.floor.id;
          if (floor.withDrawing) {
            this.withDrawing = floor.withDrawing;
          }
          this.curFloor = floor.floor;
          console.log('flatT: ', this.flat);
        }
      });
      if (this.flat && !this.withOutPrototype) {
        setTimeout(() => { this.showHotspot(this.flat); }, 3000);
        setTimeout(() => { this.showHotspot(this.flat); }, 5000);
        setTimeout(() => { this.showHotspot(this.flat); }, 7000);
        setTimeout(() => { this.showHotspot(this.flat); }, 10000);
        if (this.flat.faltPrototype !== '' || this.flat.faltPrototype !== undefined) {
          this.dataService
            .getSpecFlatPrototypeView(this.flat.faltPrototype)
            .subscribe(prototype => {
              this.flatProperties = prototype;
              if (this.flatProperties.length > 0) {
                if (this.flatProperties[0].sideNames) {
                  const flatViewName = this.flatProperties[0].sideNames[0];
                  if (this.curFloor[flatViewName]) {
                    this.items[0].curFloorPanorama = this.curFloor[flatViewName];
                    if (this.items[0].curFloorPanorama.hostname) {
                      this.isUrl = true;
                    }
                  }
                }
              }
            });
        }
      } else if (this.withOutPrototype && this.flat) {
        let array = []

        if (this.flat.curFloorPanorama) {
          if (this.flat.curFloorPanorama.indexOf("http") > -1) {
            this.isUrl = true;
          }
        }
        if (this.flat.faltPrototype !== '' && this.flat.faltPrototype !== undefined) {
          this.dataService
            .getSpecFlatPrototypeView(this.flat.faltPrototype)
            .subscribe(prototype => {
              this.flatProperties[0].protoId = prototype[0].id;
              // this.flatProperties[0].flatInterior = prototype[0].flatInterior;
            });
        }
        array.push(this.flat);
        this.flatProperties = array;
      }

      this.dataToDialog.flat = this.flat;
      this.dataToDialog.user = this.user;
    }
  }


  sendWhatsapSehel(phoneNumber) {
    this.showPhoneNumber = !this.showPhoneNumber
    this.pageTitle();
    let postData: any = {}
    // this.titleWhatsapp + '%0a' + 'להלן קישור בו ערכנו עבורך המחשת פרויקט והדירה' +  '%0a' + routeNavigate + '%0a' + freeText
    this.postData.message = this.titleWhatsappSehel + '\n' + this.routeNavigate;
    // postData.token = "spirikal-427c-4921-927b-795020264f93";

    this.postData.phone = phoneNumber;

    this.dataService.postSehel('sendWhatsapp', this.postData, 'a503d275-11a5-4283-b5d9-4b9abbd66508');

    // postData = JSON.stringify(postData);
    //   // this.http.post<any>('https://dev.sehel.co.il/api/3d/sendWhatsapp/a246afb5-427c-4921-927b-795020264f93', postData).subscribe(data => {
    //     this.http.post<any>('https://crm.sehel.co.il/api/3d/sendWhatsapp/a503d275-11a5-4283-b5d9-4b9abbd66508', postData).subscribe(data => {
    //     console.log('data', data);
    //   });
  }

  justOpenMenuMatTab() {
    this.toggleMenuTab = true;
  }

  openMenuMatTab(gal?) {
    // fix after translate - gallery view in mobile;
    this.toggleMenuTab = !this.toggleMenuTab;
    if (gal === 'gal' && !this.toggleMenuTab) {
      this.galCounter = this.galCounter + 1;
    }
    if (gal === 'plan') {
      this.propertiesMenuChangePlace = true;
    } else {
      this.propertiesMenuChangePlace = false;
    }
  }
  closeFlatProperties() {
    this.hideFlatPropeties.emit('false');
    this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid') + '/']);

    // setTimeout(function () {
    //   if (document.getElementsByClassName('3d-flat-holder').length > 0) {
    //     let obj3d = document.getElementsByTagName('app-threejs')[0];
    //     let container = document.getElementsByClassName('3d-flat-holder')[0];
    //     container.prepend(obj3d);
    //   }
    // }, 100);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(AddOfferComponent, { data: this.dataToDialog });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
  onChangeAreaCode(code) {
    this.areaCode = code
  }
  // ngOnDestroy() {
  //   this.router.routeReuseStrategy.shouldReuseRoute = function () {
  //     return false;
  //   };
  // }
  showHotspot(flat) {
    if (flat.hotspotName) {
      // this.closeViewFloors();

      const data = {
        hotspotName: flat.hotspotName,
        flatName: this.buildingName + "_" + flat.number,
        flatStatus: flat.status,
        flatFloor: flat.floorNumber,
        singleFlat: 'true'
      };

      // const data = hotspotName;
      // Set url to be sure that the message will be sent to only this url
      // Full url to iframe

      postMessageToIframe(data);


      // const url = 'https://topeye.club/';
      // //  Access iframe by name
      // // const win = window.frames.tourIframe;
      // const test = document.getElementsByClassName("da-iframe");
      // let test1: HTMLIFrameElement;
      // if (test.length > 0) {
      //   test1 = test[0].getElementsByTagName('iframe')[0];
      // }
      // const win = test1;

      // if (win) {
      //   this.iframeElement = eval("(win.contentWindow || win.contentDocument)");
      //   this.iframeElement.postMessage(JSON.stringify(data), url);
      // }
    }
  }

  isNoItemsF($event, wichGallery) {
    if (wichGallery === 'shareflatgallery') {
      console.log("shareflatgallery",)
      this.shareflatgallery = !$event;
    } else {
      this.simpleGallery = false;
    }
    if (wichGallery === 'shareflatgalleryOfBuilding') {
      this.shareflatgalleryOfBuilding = false;
    } else {
      this.simpleGallery = false;
    }
    if (wichGallery === 'plan') {

      this.plan = !$event;


    }

    console.log('no Items');
  }
  pageTitle() {
    if (this.projTile) {
      if (this.buildingTile) {
        // this.title = 'Spirikal' + ' - ' + this.compTile + ' - ' + this.projTile + ' - ' + this.buildingTile;
        if (this.items[0]) {
          this.title = this.compTitle + ' - ' + this.companyTitle + ' - ' + this.projTile + ' - ' + this.buildingTile + ' / דירה ' + this.items[0].number;
          this.titleWhatsapp = this.compTitle + '%0a' + this.companyTitle + '%0a' + this.projTile + '%0a' + this.buildingTile + '%0a' + this.propertyName + this.items[0].number + '\n';
          this.titleWhatsappSehel = this.compTitle + ' - Sehel' + '\n' + this.companyTitle + '\n' + this.projTile + '\n' + this.buildingTile + ' / דירה ' + this.items[0].number + '\n';
        }
        this.titleService.setTitle(this.title);
      }
    }
  }
  getAreaCode() {
    this.currentLang = this.translate.currentLang;
    switch (this.currentLang) {
      case 'he':
        this.areaCode = '+972';
        break;
      default:
    }
    console.log(this.translate.currentLang);
  }
  goToBuilding() {
    // if (this.compositeDesign && !this.unika) {
    //   this.router.navigate(['/company/n/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid')]);
    // } else if (this.unika) {
    //   this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid')]);
    // } else {
    //   this.router.navigate(['/company/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid')]);
    // }
    this.router.navigate([this.urlSwitcher + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid')]);

  }
  // closeFlatProperties() {
  //   this.showFlatProperties = false;
  //   const url = '/company/n/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid');
  //   // this.router.createUrlTree([], {relativeTo: flat.id, queryParams: {param: 6}}).toString()
  //   this.location.go(url);
  //   // this.router.navigate(['/company/n/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid')]);
  // }
  projPassFromMenu(proj) {
    this.proj = proj;
    let str = this.proj[0].spirical
    str = str.slice(str.indexOf('src') + 5);
    this.mainSpiricalSrc = str.slice(0, str.indexOf('"'));
    this.mainSpiricalSrcUpdated = true;
  }
  showPhoneF() {
    this.showPhone = !this.showPhone;
    this.pageTitle();
    if (this.showPhone) {
      this.showPhoneNumber = false;
    }
  }
  viewFloors(item) {
    firstStep();
    function firstStep() {
      setTimeout(function () {
        if (document.getElementsByClassName("panorama-holder")) {
          let test = document.getElementsByClassName("panorama-holder");
          if (test.length > 0) {
            if (test[0].getElementsByTagName('iframe')[0]) {
              nextStep();
            }
          }
        } else {
          firstStep();
        }
      }, 1000);
    }
    function nextStep() {
      var data = {
        scene: item.curFloorPanorama, // pano ID
        autorotate: false,
      };
      // Set url to be sure that the message will be sent to only this url
      // Full url to iframe

      postMessageToIframe(data);

      // var url = 'https://topeye.club/';


      // //  Access iframe by name
      // // var win = window.frames.tourIframe;
      // const test = document.getElementsByClassName("panorama-holder");
      // const test1 = test[0].getElementsByTagName('iframe')[0];
      // var win = test1;

      // let iframeElement = eval("(win.contentWindow || win.contentDocument)");

      // iframeElement.postMessage(JSON.stringify(data), url);
    }
  }


  toggleFullScreen(): void {
    const fsDoc = <any>document;

    if (!isFullScreen()) {
      const fsDocElem = <FsDocumentElement>document.documentElement;
      this.fullscreen = true;
      if (fsDocElem.requestFullscreen) {
        fsDocElem.requestFullscreen();
      } else if (fsDocElem.msRequestFullscreen) {
        fsDocElem.msRequestFullscreen();
      } else if (fsDocElem.mozRequestFullScreen) {
        fsDocElem.mozRequestFullScreen();
      } else if (fsDocElem.webkitRequestFullscreen) {
        fsDocElem.webkitRequestFullscreen();
      }
    } else if (fsDoc.exitFullscreen) {
      fsDoc.exitFullscreen();
      this.fullscreen = false;
    } else if (fsDoc.msExitFullscreen) {
      fsDoc.msExitFullscreen();
      this.fullscreen = false;
    } else if (fsDoc.mozCancelFullScreen) {
      fsDoc.mozCancelFullScreen();
      this.fullscreen = false;
    } else if (fsDoc.webkitExitFullscreen) {
      fsDoc.webkitExitFullscreen();
      this.fullscreen = false;
    }
  }



  bigDrawing() {
    this.fullScreenDrawing = !this.fullScreenDrawing
    if (!this.compositeDesign) {
      this.toggleFullScreen();
    }
  }
  bigSpirical() {
    this.fullScreenSpirical = !this.fullScreenSpirical
    if (!this.compositeDesign) {
      this.toggleFullScreen();
    }
  }
  bigInterior() {
    this.fullScreenInterior = !this.fullScreenInterior
    if (!this.compositeDesign) {
      this.toggleFullScreen();
    }
  }
  bigGallery() {
    this.fullScreenGallery = !this.fullScreenGallery
  }

  copyInputMessage(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.showCopyNote = true;
    let showCopyNote = this.showCopyNote;
    setTimeout(() => {
      this.showCopyNote = false;
    }, 3000);
  }




}

